import React from 'react';
import { Card, CardContent } from './ui/card';
import { Quote, Star, ArrowRight } from 'lucide-react';
import { siteContent } from '../data/mockData';

const ClientSuccess = () => {
  const content = siteContent.en?.clientSuccess || siteContent.en.clientSuccess;

  return (
    <section id="client-success" className="py-20 lg:py-32 bg-white">
      <div className="container mx-auto px-4 lg:px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-[#f0f0e8] rounded-full px-4 py-2 mb-6">
            <Quote className="w-4 h-4 text-[#c41927] mr-2" />
            <span className="text-sm font-semibold text-[#011431] uppercase tracking-wide">Client Success</span>
          </div>
          <h2 className="text-3xl lg:text-5xl font-bold text-[#011431] mb-6">
            {content.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {content.subtitle}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid lg:grid-cols-3 gap-8 mb-20">
          {content.testimonials.map((testimonial, index) => (
            <Card key={index} className="bg-white border-0 shadow-lg hover:shadow-xl transition-shadow duration-300 group">
              <CardContent className="p-8">
                {/* Stars */}
                <div className="flex mb-6">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#c41927] text-[#c41927]" />
                  ))}
                </div>
                
                {/* Quote */}
                <div className="relative mb-6">
                  <Quote className="absolute -top-2 -left-2 w-8 h-8 text-[#c41927] opacity-20" />
                  <p className="text-gray-700 leading-relaxed pl-6">
                    "{testimonial.quote}"
                  </p>
                </div>
                
                {/* Author */}
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#011431] to-[#c41927] rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold text-sm">
                      {testimonial.author.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <div className="font-semibold text-[#011431]">{testimonial.author}</div>
                    <div className="text-sm text-gray-600">{testimonial.role}</div>
                    <div className="text-xs text-[#c41927] font-medium">{testimonial.company}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Case Study Highlights */}
        <div className="bg-[#f0f0e8] rounded-2xl p-8 lg:p-12">
          <div className="text-center mb-12">
            <h3 className="text-2xl lg:text-3xl font-bold text-[#011431] mb-4">
              Success Stories in Action
            </h3>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Real results from MedQuore engagements across different company stages and regulatory requirements
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {content.caseStudies.map((caseStudy, index) => (
              <Card key={index} className="bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 group hover:-translate-y-1">
                <CardContent className="p-8">
                  <div className="flex items-center mb-4">
                    <div className="bg-[#c41927] text-white text-xs font-bold px-3 py-1 rounded-full mr-3">
                      CASE STUDY
                    </div>
                    <div className="text-sm text-gray-500">{caseStudy.industry} • {caseStudy.stage}</div>
                  </div>
                  
                  <h4 className="text-xl font-bold text-[#011431] mb-3">{caseStudy.title}</h4>
                  
                  <div className="mb-4">
                    <h5 className="font-semibold text-[#011431] text-sm mb-2">Challenge:</h5>
                    <p className="text-gray-600 text-sm leading-relaxed">{caseStudy.challenge}</p>
                  </div>
                  
                  <div className="mb-6">
                    <h5 className="font-semibold text-[#011431] text-sm mb-2">Key Results:</h5>
                    <ul className="space-y-1">
                      {caseStudy.results.map((result, idx) => (
                        <li key={idx} className="text-sm text-gray-600 flex items-start">
                          <div className="w-1.5 h-1.5 bg-[#c41927] rounded-full mt-2 mr-2 flex-shrink-0"></div>
                          {result}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <button className="flex items-center text-[#c41927] hover:text-[#a01520] font-semibold text-sm group-hover:translate-x-1 transition-all duration-300">
                    Read Full Case Study
                    <ArrowRight className="w-4 h-4 ml-1" />
                  </button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientSuccess;